/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalitybigfiveopennessright4Inputs */



/**
* | output |
* | --- |
* | "Explorer" |
*
* @param {Personalitybigfiveopennessright4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalitybigfiveopennessright4 = /** @type {((inputs?: Personalitybigfiveopennessright4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalitybigfiveopennessright4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Explorer")
	if (locale === "es") return /** @type {LocalizedString} */ ("Explorador")
	return /** @type {LocalizedString} */ ("Исследователь")
});
export { personalitybigfiveopennessright4 as "personalityBigFiveOpennessRight" }